import Axios from "axios";

export default class SearchService {

    constructor() { }


    getSubjectsAndLevels() {
        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/search/subjectsandlevels');
    }


    initialSearch(value) {
        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/search/initial', { params: {
            value
        } });
    }

    refineSearch(initialType, initialId, searchStr) {
        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/search/refine', { params: {
            initialType,
            initialId,
            searchStr
        } })
    }

    _subjects = ['MATHS', 'ENGLISH', 'ENGLISHLIT', 'PIANO', 'CELLO'];

    getSubjects(levelId) {
        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/search/subjects', {
            params: {
                levelId
            }
        });
    }

    getSubjects(levelId, count) {
        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/search/subjects', {
            params: {
                levelId,
                count,
            }
        });
    }

    getSubjectById(subjectId) {
        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/search/subject', {
            params: {
                subjectId
            }
        })
    }

    getSubjectsByName(name, levelId) {
        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/search/subjectsbyname', {
            params: {
                name,
                levelId
            }
        })
    }


    getLevelSets(subjectId) {
        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/search/levelsets', {
            params: {
                subjectId
            }
        });
    }



    _musicLevels = ['LEVEL1', 'LEVEL2'];
    _academicLevels = ['KS1', 'KS2', 'GCSE', 'ALEVEL'];

    getLevels(subjectId) {
        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/search/levels', {
            params: {
                subjectId
            }
        });
    }

    getLevelById(levelId) {
        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/search/level', {
            params: {
                levelId
            }
        })
    }


    _tutors = [
        { Name: 'Aaron', Subjects: ['Maths'], Levels: ['Key Stage 1', 'Key Stage 2'] },
        { Name: 'Billy', Subjects: ['Maths', 'English', 'Science'], Levels: ['Key Stage 1', 'Key Stage 2', 'GCSE'] },
        { Name: 'Charlotte', Subjects: ['English', 'Science'], Levels: ['Key Stage 1', 'Key Stage 2', 'GCSE', 'A-Level'] },
        { Name: 'Dave', Subjects: ['Maths', 'Science'], Levels: ['GCSE'] },
        { Name: 'Erica', Subjects: ['Piano'], Levels: ['Level 1', 'Level 2'] },
        { Name: 'Fiona', Subjects: ['Piano'], Levels: ['Level 1'] }
    ];
    
    getSearchResults(subjectId, levelId, location, pageNumber, happyToLearnOnline, studentWillTravel, distanceStudentWillTravel, tutorsName, mustAcceptStripe, mustHavePassedDbsCheck, residesIn) {

        return Axios.get(process.env.VUE_APP_API_BASE_URL + '/search/results', {
            params: {
                subjectId,
                levelId,
                lat: location.lat,
                lng: location.lng,
                studentIsHappyToLearnOnline: happyToLearnOnline ?? true,
                studentIsHappyToTravel: studentWillTravel,
                milesStudentWouldBePreparedToTravel: distanceStudentWillTravel,
                tutorsName,
                pageNumber,
                tutorMustAcceptStripePayments: mustAcceptStripe,
                tutorMustHavePassedDbsCheck: mustHavePassedDbsCheck,
                residesIn,
            }
        });

        return new Promise((resolve) => {
            var matchingTutors = this._tutors.filter(x => { return x.Subjects.includes(subject) && x.Levels.includes(level) });

            setTimeout(() => {
                resolve(matchingTutors);
            }, 500);
        });
    }

}